import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export const STORE_NAME = '$_extraPayment';

function getStore() {
  const state = {
    lastFetchTime: Date.now(),
    extraPayments: [],
    pageInfo: {},
    paymentResult: '',
  };

  return {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
  };
}

export default {
  register: (rootStore) => {
    if (rootStore.state[STORE_NAME]) {
      rootStore.unregisterModule(STORE_NAME);
    }
    rootStore.registerModule(STORE_NAME, getStore());
  },
};



// WEBPACK FOOTER //
// ./src/views/ExtraPayment/store/index.js